import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupService } from '../../../../services/lookups/lookup.service';
import {Location} from '../../../../models/user.model';
import { LookupAdminService } from '../../../../services/lookups/lookupadmin.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-country-detail',
  templateUrl: './country-detail.component.html',
  styleUrls: ['./country-detail.component.css']
})
export class CountryDetailComponent implements OnInit {
  regions: Location[] = [];
  @Output() showHideCountryDetailDlg = new EventEmitter<boolean>();
  @Output() refreshDataSource=new EventEmitter<boolean>();
  countryDetailForm: FormGroup;

  constructor(private fb: FormBuilder, 
    private lookupService: LookupService,
    private lookupAdminService:LookupAdminService,
    private notifier: NotifierService) {}

  ngOnInit() {
    this.countryDetailForm = this.fb.group({
      Id: [''],
      countryName: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_'-]*$/)]],
      region: ['', Validators.required],
      isActive:[''],
      //lastUpdatedBy:[''],
      lastUpdatedDateTime:['']
    });
  }

  showCountryDetailDialog(location:Location) {
    // console.log(id);
    //this.lookupService.getRootLocations(this.authUser._user.userType.typeName).subscribe((data: Location[]) => {
      this.lookupService.getAllRegions$().subscribe((data: Location[]) => {
      this.regions = data;
      this.regions.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
    });

    if(location!=null)
    {
      //console.log(location);
      this.countryDetailForm.patchValue({
          Id:location.id,
          countryName:location.locationName,
          region:location.parentLocation,
          isActive :String(location.isActive),
          lastUpdatedDateTime : new Date(location.lastUpdatedDateTime).toLocaleString()
      });
    }
    else
    {
      this.countryDetailForm.reset();
    }
  }
  onCancelCountryDetail()
  {
    this.countryDetailForm.reset();
    this.showHideCountryDetailDlg.emit(false);
    this.refreshDataSource.emit(true);
  }
  onSaveCountryDetail()
  {
       if(this.countryDetailForm.valid)
       {
         let country= Object.assign(new Location(),this.countryDetailForm.value);
         country.parentId = country.region.id;
         country.locationName =country.countryName;
         this.lookupAdminService.saveCountry(country).subscribe((resp)=>{
           if(resp.ok)
           {
            this.notifier.notify('success', 'Country saved successfully');
           }

       },error=>{
          this.notifier.notify('error', 'Failed to save Country, contact tech support');
          });
         
        //this.refreshDataSource.emit(true);

       }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/admin/lookup-management/country/country-detail/country-detail.component.ts